export default __webpack_public_path__ + "static/media/k3.ad75cb70.svg";